import { spLogTags, structuredCloneL } from '@eventr/common'
import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from './bound.store'
export type IfilterValues = {
    [key: string]: string
}
interface IFliterContext {
    filteredValues: any
    filterValues: () => any
    filterOptions: (
        searchFilter: string,
        filterOptions: IfilterValues[]
    ) => string[]
    filterData: (searchFilter: string) => any
}

const FilterContext = createContext<IFliterContext>({
    filteredValues: {},
    filterValues: () => [],
    filterOptions: () => [],
    filterData: () => { },
})

export const FilterProvider = (props: { children: React.ReactNode }) => {
    const { selectedItinerary, getV2Value } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItinerary: s.selectedItinerary,
                getV2Value: s.getV2Value,
            }
        })
    )
    const [filteredValues, setFilteredValues] = useState<any>({})

    const filterValues = useCallback(() => {
        if (selectedItinerary?.v2) {
            let valsObj: Record<string, { [key: string]: string }> = {}
            selectedItinerary?.v2.forEach((d) => {
                if (d.data) {
                    if (d?.rendererOptions?.settings?.filterCriteria) {
                        let id = d.sectionID
                        let key = Object.keys(d.data)[0]
                        const filterCriteria =
                            d?.rendererOptions?.settings.filterCriteria
                        let resultArray: { [key: string]: string } = {}
                        if (key && d.data[key]) {
                            d.data[key].forEach((e: any) => {
                                if (
                                    filterCriteria &&
                                    filterCriteria.length > 0
                                ) {
                                    let results = ''
                                    filterCriteria.forEach((f) => {
                                        results +=
                                            getV2Value(f, e).toLowerCase() +
                                            ', '
                                    })
                                    resultArray[e._id] = results
                                }
                            })
                        } else {
                            if (key) {
                                spLogTags('Error data[key]: ' + d.sectionID, [
                                    'error',
                                ])
                                return
                            } else {
                                spLogTags(
                                    'Error with key: ' +
                                    key +
                                    ' in section: ' +
                                    d.sectionID,
                                    ['ERROR']
                                )
                                return
                            }
                        }

                        valsObj[id] = resultArray
                        return { [id]: resultArray }
                    }
                }
            })
            return valsObj
        }
    }, [selectedItinerary, getV2Value])

    useEffect(() => {
        setFilteredValues(filterValues())
    }, [selectedItinerary, filterValues])

    //my aim here is to take the information from data provider and filter it
    const filterOptions = (
        searchFilter: string,
        filterOptions: IfilterValues[]
    ) => {
        let filteredData: string[] = []
        filterOptions.forEach((d) => {
            let id = Object.keys(d)[0]
            let data = d[id]
            let added = false
            if (!added && data.includes(searchFilter.toLowerCase())) {
                filteredData.push(id)
            }
        })

        return filteredData
    }

    const filterSectionData = (searchFilter: string, section: any) => {
        //section will return data if string exhists insection and undefined if not

        if (filteredValues[section.sectionID]) {
            let stringData = JSON.stringify(section.data).toLowerCase()

            if (searchFilter && stringData.includes(searchFilter)) {
                const sectionID = section.sectionID
                let id = Object.keys(section.data)[0]
                let y = section.data[id]
                    .map((e: any) => {
                        if (
                            filteredValues[sectionID][e._id] &&
                            filteredValues[sectionID][e._id].includes(
                                searchFilter
                            )
                        ) {
                            return e
                        } else {
                            return undefined
                        }
                    })
                    .filter((e: any) => e !== undefined)
                section.data[id] = y
                return section
            } else {
                return undefined
            }
        } else {
            return undefined
        }
    }

    const filterData = (
        searchFilter: string,
        data: any = selectedItinerary?.v2
    ) => {
        if (!data) {
            return
        }
        data = structuredCloneL(data)
        if (searchFilter === undefined || searchFilter.length <= 1) {
            return data
        } else {
            return data
                .map((d: any) => {
                    return filterSectionData(searchFilter, d)
                })
                .filter((d: any) => d !== undefined)
        }
    }

    return (
        <FilterContext.Provider
            value={{
                filteredValues,
                filterValues,
                filterOptions,
                filterData,
            }}
        >
            {props.children}
        </FilterContext.Provider>
    )
}
export const useFilterContext = () => {
    return useContext(FilterContext)
}
